import { render } from "./TradePersonBenefitsModal.vue?vue&type=template&id=7ed15ed6&ts=true"
import script from "./TradePersonBenefitsModal.vue?vue&type=script&lang=ts"
export * from "./TradePersonBenefitsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__